<div class="input-dropdown-component">
  <ng-select 
    #ngSelect
    [readonly]="readOnly"
    [searchable]="searchable"
    [formControl]="currentFormControl"
    [clearable]="true"
    [virtualScroll]="true"
    placeholder="Selecione uma opção"
    (change)="onTypeChange($event)">
    <ng-option *ngFor="let option of options" [value]="option.valor">{{
      option.titulo
    }}</ng-option>
  </ng-select>
</div>
